/**
 * Reads a Server-Sent Events stream and calls onEvent for each parsed JSON event.
 * Caller is responsible for building the fetch request; this handles the reader loop.
 */
export const readSSEStream = async (response, onEvent) => {
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split('\n');
    buffer = lines.pop();
    for (const line of lines) {
      if (!line.startsWith('data: ')) continue;
      try {
        onEvent(JSON.parse(line.slice(6)));
      } catch {
        // skip malformed events
      }
    }
  }
};
